import { BASIC_NODE_CONFIG, BASIC_NODE_CONFIG_SIZE } from 'src/utils/basic'
import type { OutputNodeType } from '../types'

export function generateOutputNodeConfig(): OutputNodeType {
  return {
    ...BASIC_NODE_CONFIG,
    id: '1',
    type: 'output',
    data: {
      ...BASIC_NODE_CONFIG_SIZE,
      nodeName: '输出节点',
      nodeType: 'output',
      nodeData: {},
      nodeStyle: {},
      nodeId: '',
      hasErr: false,
      errInfo: [],
    },
    deletable: false,
    position: {
      x: 0,
      y: 0,
    },
  }
}
